// extracted by mini-css-extract-plugin
export var aboutContent = "AboutSection-module--about-content--6e229";
export var aboutContentTwo = "AboutSection-module--about-content-two--f051a";
export var aboutSection = "AboutSection-module--about-section--afba8";
export var aboutimg = "AboutSection-module--aboutimg--b8c80";
export var extratopmargin = "AboutSection-module--extratopmargin--cec4e";